import React, { useEffect, useRef, useState } from "react";
import InfoIcon from "@material-ui/icons/InfoOutlined";
import { Tooltip } from "@my-scoot/component-library-legacy";
import Popover from "@material-ui/core/Popover";
import Button from "@material-ui/core/Button";
import classnames from "classnames";
import { CLICK_RATE_POPOVER_KEY } from "ui/pages/communications/CustomEmail/components/EmailListItem/EmailListItem.constants";

// Prevent multiple popovers in the same page render
let hasAutoOpened = false;

export const ClickRatePopover = ({
  tooltipText,
  popoverText,
  shouldAutoOpen = true,
  localStorageKey = CLICK_RATE_POPOVER_KEY,
  iconStyle = {},
  iconClassName = "",
  wrapperClassName = "",
  fontSize = 16,
}) => {
  const infoIconRef = useRef(null);
  const [anchorEl, setAnchorEl] = useState(null);

  useEffect(() => {
    if (!shouldAutoOpen) return;

    const hasSeen = localStorage.getItem(localStorageKey);

    // Already shown before OR another card has already claimed it
    if (hasSeen || hasAutoOpened) {
      return;
    }

    // Claim the auto-open so no other card does it
    hasAutoOpened = true;

    const timer = setTimeout(() => {
      if (infoIconRef.current) {
        setAnchorEl(infoIconRef.current);
      }
    }, 1000); // 1 second delay

    return () => clearTimeout(timer);
  }, [shouldAutoOpen, localStorageKey]);

  const handleClosePopover = () => {
    localStorage.setItem(localStorageKey, "true");
    setAnchorEl(null);
  };

  return (
    <div
      className={classnames("tw-inline-flex tw-items-center", wrapperClassName)}
    >
      <Tooltip arrow color="primary" placement="top" title={tooltipText}>
        <InfoIcon
          ref={infoIconRef}
          className={iconClassName}
          style={{
            fontSize,
            color: "#A6A6A6",
            cursor: "pointer",
            ...iconStyle,
          }}
        />
      </Tooltip>

      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClosePopover}
        anchorOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        PaperProps={{
          style: {
            padding: 16,
            maxWidth: 300,
            borderRadius: 8,
          },
        }}
      >
        <div>
          <div className="tw-text-[14px] tw-mb-[10px]">{popoverText}</div>

          <div className="tw-flex tw-justify-end">
            <Button
              variant="contained"
              color="primary"
              onClick={handleClosePopover}
            >
              Okay
            </Button>
          </div>
        </div>
      </Popover>
    </div>
  );
};
